import {
    GetMultiAllocationWorksheetsResponse
} from "src/models/multidimensional-allocation/GetMultiAllocationWorksheetsResponse";
import {MultiAllocationWorksheetData} from "src/models/multidimensional-allocation/MultiAllocationWorksheetData";
import Placeholder from "src/models/tp-allocation/Placeholder";
import {MultiAllocationDataSourceRecord} from "src/models/multidimensional-allocation/MultiAllocationDataSourceRecord";
import {MultiAllocationWorksheetExecution} from "src/models/multidimensional-allocation/MultiAllocationWorksheetExecution";

export interface MultidimensionalAllocationState {
    isLoading: boolean;
    dataSourcesNeedRefresh: boolean;
    sevenSegmentLOVMap: Map<string, string[]>;
    selectedWorksheet?: MultiAllocationWorksheetData;
    dataSourceRecords?: MultiAllocationDataSourceRecord;
    error?: string;
    viewMode?: string;
    allocationCalculations?: GetMultiAllocationWorksheetsResponse;
    placeholdersMap?: Map<string, Placeholder[]>;
    entityDetailsNeedRefresh?: boolean;
    selectedExecutionPeriod?: string | null;
    worksheetExecution?: MultiAllocationWorksheetExecution | null;
    executionPeriodWasTouched?: boolean;
}

export const initialState: MultidimensionalAllocationState = {
    isLoading: false,
    dataSourcesNeedRefresh: false,
    sevenSegmentLOVMap: new Map(),
    selectedExecutionPeriod: null,
    worksheetExecution: null,
    executionPeriodWasTouched: false
};
